export const BRAINBOOST_PLAYER_IFRAME_PARENT = 'brainboost-player';
